window.countChip = function (name, value) {
  const targetList = document.getElementsByClassName('js-countChip--' + name)
  value = parseInt(value, 10)
  if (value > 0) {
    for (const iterator of targetList) {
      iterator.innerText = value
      iterator.classList.add('active')
    }
  } else {
    for (const iterator of targetList) {
      iterator.classList.remove('active')
    }
  }
}
